import moment from 'moment'

import styles from './DateTooltip.module.scss'

const DateTooltip = ({
  paymentMethod,
  paymentPeriod,
  packagePlans,
  packageFee,
  discount,
  monthlyFeeAfterDiscount,
  isVisible
}) => {
  if (!isVisible) return null

  return (
    <div className={styles.tooltip}>
      {paymentMethod && (
        <div className={styles.row}>
          <span className={styles.label}>Payment Method</span>
          <span className={styles.value}>{paymentMethod}</span>
        </div>
      )}
      {paymentPeriod && (
        <div className={styles.row}>
          <span className={styles.label}>Billing Frequency</span>
          <span className={styles.value}>{paymentPeriod}</span>
        </div>
      )}
      {packagePlans && (
        <div className={styles.row}>
          <span className={styles.label}>Package Plans</span>
          <span className={styles.value}>{packagePlans}</span>
        </div>
      )}
      {(packageFee || discount || monthlyFeeAfterDiscount) && (
        <>
          <div className={styles.separator} />
          {packageFee && (
            <div className={styles.row}>
              <span className={styles.label}>Package Fee</span>
              <span className={styles.value}>
                {parseFloat(packageFee).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD'
                })}
              </span>
            </div>
          )}
          {discount > 0 && (
            <div className={styles.row}>
              <span className={styles.label}>Discount</span>
              <span className={styles.value}>
                {parseFloat(discount).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD'
                })}
              </span>
            </div>
          )}
          {monthlyFeeAfterDiscount && (
            <div className={styles.row}>
              <span className={styles.label}>Monthly Fee (After Discount)</span>
              <span className={styles.value}>
                {parseFloat(monthlyFeeAfterDiscount).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD'
                })}
              </span>
            </div>
          )}
        </>
      )}
      {!paymentMethod && !paymentPeriod && !packageFee && (
        <div className={styles.row}>
          <span className={styles.value}>No billing info available</span>
        </div>
      )}
    </div>
  )
}

export default DateTooltip
